precision mediump float;

#pragma glslify: ease = require(glsl-easings/cubic-out)

#include <common>

uniform float uTime;
uniform float uScale;
uniform sampler2D tNoise;

attribute vec4 particlePositionsStartTime;
attribute vec4 particleVelLife;
attribute vec4 particleColSpeed;

varying float vOpacity;
varying vec4 vColor;

//quartic out
// float ease(float t) {
//   return pow(t - 1.0, 3.0) * (1.0 - t) + 1.0;
// }

void main() {

  vColor = vec4(particleColSpeed.rgb, 1.0);

  float timeElapsed = uTime - particlePositionsStartTime.w;
  float lifeLeft = 1.0 - timeElapsed / particleVelLife.w;

  vec3 velocity = vec3(particleVelLife.xyz);
  vec3 startPosition = vec3(particlePositionsStartTime.xyz);
  vec3 currentPosition = startPosition + (velocity * particleColSpeed.w * timeElapsed * 1000.0);
  // vec4 noiseOffset = texture2D(tNoise, vec2((currentPosition.xy + vec2(vColor.r * vColor.g + lifeLeft, vColor.g * vColor.b + lifeLeft)) * 0.025));
  vec4 noiseOffset = texture2D(tNoise, vec2(currentPosition.y * 0.05, (startPosition.x + startPosition.z * particleVelLife.w) * 1000.0));
  currentPosition.x += ((noiseOffset.r - 0.5) * 2.0) * 0.5;
  currentPosition.z += ((noiseOffset.b - 0.5) * 2.0) * 0.5;

  vec3 transformed = vec3(currentPosition);
	#include <project_vertex>

  if(timeElapsed > 0.0 && lifeLeft > 0.0) {
    vOpacity = ease(lifeLeft) * min(1.0 / abs(mvPosition.z * 0.2), 1.0);
    gl_PointSize = uScale * (1.0 - lifeLeft) * (1.0 / abs(mvPosition.z));
    gl_Position = projectionMatrix * modelViewMatrix * vec4(currentPosition, 1.0);
  } else {
    vOpacity = 0.0;
    gl_PointSize = 0.0;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(0.0, 0.0, 0.0, 1.0);
  }
}